const featureFlagQueries = {
  list: (flagNames: Array<string>) => ["feature-flag", flagNames],
};

export default featureFlagQueries;
